import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { PIECE_WAGE_PRICE_TYPE } from "../../utils/Utils";

const PIECE_WAGE_PRICE_TYPE_OPTIONS = Object.keys(PIECE_WAGE_PRICE_TYPE).map((c) => ({
  label: PIECE_WAGE_PRICE_TYPE[c],
  value: c,
}));

const DEFAULT_EMPLOYEE_PAY_IN_OUT = {
  id: "",
  name: '',
  price: "",
  priceType: PIECE_WAGE_PRICE_TYPE_OPTIONS[0].value,
  percentWorker: '',
  percentShiftLeader: '',
  percentCompany: '',
};

const PieceWageCategoryManager = () => {
  const clearPagi = useRef();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
    trigger,
  } = useForm({
    defaultValues: DEFAULT_EMPLOYEE_PAY_IN_OUT,
  });

  const priceType = watch('priceType');
  const price = watch('price');
  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [options, setOptions] = useState([
    {
      description: '',
      value: '',
    }
  ]);


  const colTable = [
    {
      Header: "STT",
      accessor: (item) => item.id,
    },
    {
      Header: "Tên",
      accessor: (item) => item.name,
    },
    {
      Header: "Loại giá",
      accessor: (item) => PIECE_WAGE_PRICE_TYPE[item.priceType],
    },
    {
      Header: "Loại(đ)",
      className: 'text-right',
      accessor: (item) => item.priceType === 'OPTIONS'
        ? JSON.parse(item.price || '{}').map(e => <div><strong>{e.description}</strong>: <NumericFormat
          displayType={"text"}
          value={e.value || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        /></div>)
        : <NumericFormat
          displayType={"text"}
          value={item.price || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
    },
    {
      Header: "Phần trăm công nhân(%)",
      className: 'text-right',
      accessor: (item) => item.percentWorker ? <NumericFormat
        displayType={"text"}
        value={item.percentWorker || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      /> : ''
    },
    {
      Header: "Phần trăm trưởng ca(%)",
      className: 'text-right',
      accessor: (item) => item.percentShiftLeader ? <NumericFormat
        displayType={"text"}
        value={item.percentShiftLeader || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      /> : ''
    },
    {
      Header: "Phần trăm công ty(%)",
      className: 'text-right',
      accessor: (item) => item.percentCompany ? <NumericFormat
        displayType={"text"}
        value={item.percentCompany || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      /> : ''
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Sửa</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];


  // Changing state value when searching name
  useEffect(() => {
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {

      GET(`employee/piece-wage-category`, {}, true)
        .then(({ data }) => {
          setData([...data]);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`employee/piece-wage-category/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
        if (data.priceType === 'OPTIONS') {
          setOptions(JSON.parse(data.price || '{}'));
        }
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const {
      name,
      price,
      priceType,
      percentWorker,
      percentShiftLeader,
      percentCompany,
    } = getValues();

    if (priceType === 'OPTIONS') {
      if (options.find(e => e.value === '')) {
        setValue('price', "")
        trigger('price')
        return;
      }
    }

    const formData = {
      name,
      price,
      priceType,
      percentWorker: percentWorker || null,
      percentShiftLeader: percentShiftLeader || null,
      percentCompany: percentCompany || null,
    };

    const request = editId
      ? PUT(`employee/piece-wage-category/${editId}`, formData, {}, true)
      : POST("employee/piece-wage-category", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
        setOptions([])
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false, isScan: false });
    reset(DEFAULT_EMPLOYEE_PAY_IN_OUT);
    setEditedId();
    setDeleteId();
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`employee/piece-wage-category/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };


  const onAddOptionsPrice = () => {
    const temp = [...options];
    temp.push({});
    setOptions(temp);
    setValue('price', JSON.stringify(temp));
  }

  const onDeleteOptionsPrice = (i) => {
    const temp = [...options];
    temp.splice(i, 1);
    setOptions(temp);
    setValue('price', JSON.stringify(temp));
  }

  const onUpdateOptionsPrice = (key, value, i) => {
    const temp = [...options];
    temp[i][key] = value;
    setOptions(temp);
    setValue('price', JSON.stringify(temp));
  }

  return (
    <React.Fragment>
      <Head title="Quản lý danh mục xuống hàng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Danh mục xuống hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm danh mục</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">{editId ? "Sửa" : "Thêm"}</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tên
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            className="form-control"
                            name="name"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                            disabled={editId}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Loại giá trị
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="priceType"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                isDisabled={editId}
                                name={name}
                                options={PIECE_WAGE_PRICE_TYPE_OPTIONS}
                                value={PIECE_WAGE_PRICE_TYPE_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => {
                                  setValue('price', '');
                                  onChange(val.value)
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="priceType"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label d-flex justify-content-between w-100" >
                          <span>Giá trị <span className="text-danger">*</span></span>{['OPTIONS'].includes(priceType) && <Button type='button' className={'btn-primary'} onClick={onAddOptionsPrice}>Thêm</Button>}
                        </label>
                        <div className="form-control-wrap">
                          <input
                            className={`form-control ${['OPTIONS'].includes(priceType) ? 'd-none' : ''}`}
                            name="price"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          {['OPTIONS'].includes(priceType) && <ul>
                            {options.map(({ description, value }, i) =>
                              <li key={i} className="d-flex mt-2">
                                <Input value={description} placeholder="Nội dung" onChange={(e) => onUpdateOptionsPrice('description', e.target.value, i)} />
                                <NumericFormat
                                  placeholder="Giá tiền(đ)"
                                  className="form-control"
                                  type="text"
                                  value={value}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={2}
                                  onValueChange={(val) =>
                                    onUpdateOptionsPrice('value', val.floatValue, i)
                                  }
                                />
                                <Button type='button' className={'btn-danger'} onClick={() => onDeleteOptionsPrice(i)}>xoá</Button>
                              </li>
                            )}

                          </ul>
                          }

                          <ErrorMessage
                            errors={errors}
                            name="price"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Chia phần trăm công nhân
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="percentWorker"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="percentWorker"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Chia phần trăm trưởng ca
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="percentShiftLeader"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="percentShiftLeader"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Chia phần trăm công ty
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="percentCompany"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="percentCompany"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit">
                        <span>{editId ? "Sửa" : "Thêm"}</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá giao dịch này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default PieceWageCategoryManager;
